/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit, Input, ViewChild,ChangeDetectionStrategy, ViewEncapsulation,SimpleChanges  } from '@angular/core';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { AppDataService }  from '../../services/app-data.service';
import { CompanyService }  from '../../services/company.service';
import {RecipeBean} from "../../beansts/recipe.bean"
import { WalletService }  from '../../services/wallet.services';
import { TranslationService } from '../../services/translation.service';
import { WritBean } from '../../beansts/quests/writ.bean';
import { ActivatedRoute} from '@angular/router';

declare var $ : any;
declare var Swal: any

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    templateUrl:'npc-modal-component.html',
    providers  : [],

  })
export class NPCPageComponent implements OnInit {
    public ngOnInit() : any {
      

    this._routeParams.queryParams.subscribe(params => {
      var uid = params['uid'];
      var objectId = params['item'];
      var room = params['room'];

          this._companyService.getUserByUid(uid).then(v=>{
            this._appData.instagramUser=v.data();
            document.getElementById('gameFrame').remove();      
/*           setTimeout(()=>{
              let npc="1715186859396"
              this.kind='npc'
              this._appData.npc={npcId:npc}
              this.reload();
            },5000) */
/*           setTimeout(()=>{
              let npc="1715186859396"
              this.kind='shopify'
              this._appData.npc={npcId:npc}
              this.getShopify(303406579880);
            },5000)
*/

      }) 
      this._companyService.getRoom(room).get().then(v=>{
        this._appData.room=v.data();
      }) 


      })

      window.onmessage = (e) => {
        console.log(e.data)
          switch  (e.data.kind) {
            ////videoconference iframe actions
            case 'loading':{
              this.kind='loading'
              break
            }            
            case 'npcChange':{
              let npc=e.data.npcId
              this.kind='npc'
              this._appData.npc={npcId:npc}
              this.reload();
              break
            }
            case 'containerChange':{
              let categoria=e.data.boardId
              this.kind=e.data.type
              this.getShopify(categoria);
              break
            }

            case 'mediaChange':{
              let param=e.data.param
              if (param.image){
                this.thumbnail=param.image;
                console.log(this.thumbnail)
              }
              if (param.video){
                this.video=param.video;
              }
              this.dialog=param.text
              console.log(this.dialog)
              this.questions=[]
              this.npcDialog={name:param.name,questions:[]}
              this.kind='npc'
              break;
            }
            case 'embedChange':{
              let param=e.data.param
              if (param.link){
                this.video=param.link;
              }
              this.kind='embed'

            }            
          }
        }
  
    }
    constructor( public _sanitizer: DomSanitizer,public translate: TranslationService,public _appData : AppDataService, public _companyService: CompanyService,public _walletService: WalletService,public _routeParams : ActivatedRoute) {
    }
    public npcDialog;
    public questions;
    public dialog;
    public question
    public itens;
    public kind='loading';
    public writ;
    public job;
    public userWrit;

    public video;
    public thumbnail;

    //    $('#npcReload').click();
    public getShopify(id){
      this.itens=[];
      this._companyService.getShopifyItens(id).subscribe(v=>{
        let i=JSON.parse(v['_body']);
        i.products.forEach(it=>{
          let variants=it.variants
          let price=''
          if (variants){
            price=variants[0].price
          }
          let nameVec=it.title.split(' ')
          let url='https://b9183d-5.myshopify.com/products/'+it.handle
          this.itens.push({
            thumbnail:it.image ? it.image.src : '',
            name:it.vendor,
            description:it.title,
            url:url,
            price:price
          })
        })
        console.log(i)



      })
    }
    public reload(){
    let npc=this._appData.npc;
    this.npcDialog={welcome:'buscando',questions:[]}
    this._companyService.getNpcDialog(npc.npcId).get().then(val=>{
      this.npcDialog=val.data();
      this.questions=[]
      if ( this.npcDialog.questions){
        this.npcDialog.questions.forEach(v=>{
          if (v.stream) {
            if (this._appData.stream==v.stream){
              this.questions.push(v)
            }
          }
          else {
            this.questions.push(v)
          }
        });
  
      }
      if (this.npcDialog.video){
        this.video=this.npcDialog.video+'?autoplay=1&enablejsapi=1';
      }
      this.thumbnail=this.npcDialog.thumbnail;
      if (npc.distance>400){
        Swal.fire({title:'Você está longe da interação',text:'Se aproxime para interagir'})
        return;
      }
      this.dialog=this.npcDialog.welcome
      $('#npcModal').modal({backdrop: 'static', keyboard: false})//"show");
      $('#npcModal').modal('show')//"show");
      setTimeout(v=>{
      $("#npcModal").on("hidden.bs.modal",  ()=> {

        this.video=null;
                // do something…
                let writ=null
                this.questions.forEach(q=>{
                  if (q.writAssociation || q.writTest){
                    writ=true
                  }
                })
                if (writ){
                  Swal.fire({title:'Falha',text:'Você não pode pular essa conversa pois está associada a uma tarefa. Responda as perguntas para poder continuar.',allowOutsideClick: false}).then(v=>{
                    $("#npcReload").click();
                  })
                }
                else{
                  var iframe = document.getElementById('gameFrame');
                  iframe.focus();

                }

      })
    },1000)

      if (this.npcDialog.writTest){
        let writ = new WritBean();
        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
        //writ.testJob(this.npcDialog.writTest)
        if (this.npcDialog.writTest.onFail){
          this._companyService.getUserWrit(this._appData.instagramUser,this.npcDialog.writTest.group.toString()).get().then(val=>{
            let wrt=val.data();
            if (wrt){//i have a writ to solve with this question
              let job=wrt.jobs[this.npcDialog.writTest.job];
              if (!job){
                this.dialog=this.npcDialog.writTest.onFail
                this.questions=[]
              }

            }
            else{
              this.dialog=this.npcDialog.writTest.onFail
              this.questions=[]
            }
          })
        }
      }
//      else{
  //      this.dialog=this.npcDialog.welcome
//        $('#npcModal').modal("show");
    //  }
    })

    }
    public doAction(question){
      switch (question.action.id){
        case 1:{
          break;
        }
        case 2:{
          break;
        }
        case 3:{
          break;
        }
        case 4:{//teleport
          this.sendIframeMessage({
            kind:'updateUserStatus',
            params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:question.action.param.x,y:question.action.param.y}}
          });
          break;
        }
        case 5:{//item
          this._companyService.getRecipesRef(this._appData.event).doc(question.action.param.item.toString()).get().then(it=>{
            let item=new RecipeBean();
            item.parse(it.data());
            item.baseQuantity=question.action.param.quantity;
            this._appData.userEventContainer.push(item);
            this._companyService.addToUserContainer(this._appData.instagramUser,item)
          })
          break;
        }
        case 6:{//skill
          break;
        }
        case 7:{//Periodic reward
          let date=new Date();
          let time=date.getTime();
          let param=question.action.param;
          let periodicity=param.periodicity;//em minutos qto tempo tem q passar pra pessoa receber.
          let miliPerid=periodicity*60*1000
          let whatToGain=param.item;
          //find item on inventory
          this._companyService.getLastNPCRequest(this.npcDialog,this._appData.instagramUser).get().then(val=>{
            let data=val.data();
            let canAdd=false;
            let lastClick=0;
            if (!data){
              //nada achado
              canAdd=true;
              lastClick=time;
            }
            else{
              lastClick=data.lastClick;
              let dif=time-lastClick;//diferenca em milisegundos
              if (dif>miliPerid){
                canAdd=true;
              }
            }
            if (canAdd){
              let quantity=question.action.param.quantity;
              this._companyService.getRecipesRef(this._appData.event).doc(whatToGain).get().then(it=>{
                let rec=new RecipeBean();
                rec.parse(it.data());
                if (quantity<0){
                    let skill=this._appData.userEventSkills[rec.skillId]
                    quantity=Math.floor(-1*quantity*skill.value);
                }
                this.addItemToInventory(quantity,rec.toItem(),time,miliPerid)

              });
            }
            else{
              let dif=time-lastClick
              let p=Math.floor((periodicity*1000-dif)/(60*1000))+1
              Swal.fire({title:'Pedido recusado',text:'Você coletou sua gratificação a pouco tempo tem que aguardar '+p+' minutos para tentar novamente'})
            }

          })
        }
      }
      if (question.action=='giveItem'){
        let onetime=question.param.onetime;
        let itemid=question.param.id;
        let itemquantity=question.param.quantity;
        let itemName=question.param.name;
        let giver=this.npcDialog.id
        let itemKind=question.param.kind;
        let thumbnail=question.param.thumbnail;
        let where=question.param.where;
        let action=question.param.action;
        let src=question.param.src;
        let itemExist=this._appData.userEventContainer.filter(val=>{
          return val.giver==giver;
        })
        let exists=false;
        if (itemExist.length!=0) {
          exists=true;
        }

        if (onetime){
          if (exists) {
            Swal.fire({title:'Você já recebeu este item',text:'Você já recebeu este item e não pode receber novamente.'})
          }
          else{
            let item={
              objectId:itemid,
              name:itemName,
              kind:itemKind,
              quatity:itemquantity,
              thumbnail:thumbnail,
              giver:giver,
              where:where,
              action:action,
              src:src
            }
            this._companyService.addToUserContainer(this._appData.instagramUser,item).then(val=>{
              this._appData.userEventContainer.unshift(item)
            })
          }
        }
        else{

        }

      }
    }
    public sendIframeMessage(messageKind){
      var iframe = document.getElementById('gameFrame');
      iframe.focus();
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }

    public addItemToInventory(quantity,itemToAdd,time,lastClick){

      if (itemToAdd.recipeId=='1634834260810'){
        //need to add quantity lamports to user
        this._walletService.sendLamports(this._appData.instagramUser,quantity).subscribe(val=>{
          this._companyService.getLastNPCRequest(this.npcDialog,this._appData.instagramUser).set({
            lastClick:time,
            oldClick:lastClick
          })
          Swal.fire({title:this.translate.instant('SUCCESS'),text:"Sua bonificação foi acrescentada na sua carteira. Aproveite."})
        });
      }
      else{
      }

    }
    isImage(thumbnail: string): boolean {
      // Verifica se o thumbnail tem extensão de imagem comum (por exemplo, .jpg, .png, .gif)
      return thumbnail && (thumbnail.endsWith('.jpg') || thumbnail.endsWith('.png') || thumbnail.endsWith('.gif'));
    }


    public expandLink(){
      this._companyService.openExternalLink(this.video,false)

    }
    public askQuestion(question){
      let welcome=question.welcome
      let onWritComplete=question.onWritComplete;
      let onWritIncomplete=question.onWritIncomplete

      let myDialogNow=this.dialog
      if (question.video){
        this.video=question.video+'?autoplay=1&enablejsapi=1';
      }
      else{
        this.video=null
      }
      if (question.thumbnail){
        this.thumbnail=question.thumbnail;
      }


      //solve actions and writs
      if (question.action && !question.rewardAction){
        this.doAction(question)
      }
      let writ=null
      if (question.writ){  //I have a job to give
        writ=new WritBean();
        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
        writ.giveJob(question.writ,null,null);
      }
      else if (question.writAssociation){//this question solves a writ
        //check if i have the associated writ to solve
        writ=new WritBean();
        question.writAssociation.answer=question.question
        question.writAssociation.question=myDialogNow
        question.writAssociation.success=question.isRight? question.isRight : false;;

        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
        if (question.writTest){
          question.writTest.completed=question.isRight ? question.isRight : false;
          writ.associateJob(question.writAssociation,question.writTest);
        }
        else{
          writ.associateJob(question.writAssociation,false);
        }


      }
      else if (question.writTest){
        writ=new WritBean();
        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
        question.writTest.completed=question.isRight ? question.isRight : false;
        writ.testJob(question.writTest);
      }

      if (writ){
        let interval=setInterval(()=>{
          if (writ.processCompleted){
            this.updateQuestion(question)
            clearInterval(interval);
          }
        },1000)
      }
      else{
        this.updateQuestion(question)
      }

    }

    public updateQuestion(question){

        if (question.id==-1){
          this.questions=this.npcDialog.questions;
          this.dialog=this.npcDialog.welcome
          if (this.npcDialog.video){
            this.video=this.npcDialog.video+'?autoplay=1&enablejsapi=1';
          }
          if (this.npcDialog.thumbnail){
            this.thumbnail=this.npcDialog.thumbnail;

          }

        }
        else{
          this.dialog=question.answer;
          if (question.goto){
            let newquestion=this.questions[question.goto]
            if (newquestion.questions){
              this.questions=newquestion.questions
            }
            else{
              this.questions=[];
            }
          }
          else if (question.questions){
            this.questions=question.questions;
          }
          else if (question.link){
            this.questions=this.npcDialog[question.link]
          }
          else{
            this.questions=[];
          }
          let hasBack=false;
          this.questions.forEach(val=>{
            if (val.id==-1){ hasBack=true;}
          })
          if (question.noBack) hasBack=true;
          if (!hasBack){
            this.questions.push({id:-1,question:"Perguntas anteriores"})
          }
        }
        if (question.trigger){
          if (question.trigger.kind=='teleport'){
            this.sendIframeMessage({
              kind:'updateUserStatus',
              params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:question.trigger.x,y:question.trigger.y}}
            });
          }
          if (question.trigger.kind=='roomTeleport'){
            this._appData.instagramUser.room=question.trigger.param.roomToGo;
            let domain=window.location.origin
            window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+question.trigger.param.roomToGo;
          }
          if (question.trigger.kind=='openLink'){
            window.open(question.trigger.param.link, "_blank");
          }
          if (question.trigger.kind=='databaseNotification'){
            //vai pegar nos param da trigger o identificador do dB trigger.param.identifier
            //uid do usuario this._appData.instagramUser.uid
            //vai no banco de dados, seleciona a collection 'triggerData' buscando documento identifier collection 'users' documento uid
            //documento final tem os seguintes parametros
            //this._companyService.<<method>>
  /*          const identifier = question.trigger.param.identifier;
            const uid = this._appData.instagramUser.uid;

            this._companyService.getTriggerData(identifier, uid)
              .then(() => {
                            Swal.fire({
                              title:'param1',
                              text:'param2',
                              html:'param3',
                              img:'url - param4',
                              read:'lido ou nao',
                            })
                          }
                    )
                  .catch((error) => {
                    console.error('Erro ao buscar documento no banco de dados:', error);
                  }
            );*/
          }

        }


    }


    //if user has item required, it must be removed from inventory.
    //once removed, the reward action must be done


    public rewardWritCompleted(wrt,question){
        if (wrt.itemReq){
          for (let i=0;i<this._appData.userEventContainer.length;i++){
            let item=this._appData.userEventContainer[i]
            if (item.objectId==wrt.itemReq.id){
                this._appData.userEventContainer.splice(i,1)
                this._companyService.removeFromUserContainer(this._appData.instagramUser,item)
                break;
            }

          }
        }
        if (question.rewardAction){
          this.doAction(question)
        }
        wrt.rewarded=true;
        this._companyService.getUserWrit(this._appData.instagramUser,wrt).set(wrt);
    }

    public checkWritCompleted(wrt,onWritIncomplete,onWritComplete){
      if (wrt.itemReq.id!=-1){
        //check if item on bag
        let itemfilter=this._appData.userEventContainer.filter(val=>{
          return val.objectId==wrt.itemReq.id;
        })
        if (itemfilter.length>0){
          let myitem=itemfilter[0]
          if (myitem.quantity==wrt.itemReq.quantity){
            //job complete
          }
          else{
            this.dialog=onWritIncomplete;

          }
        }
        else{
          this.dialog=onWritIncomplete;
        }
      }
      else if (wrt.skillReq.id!=-1){
        //check if skill right
        let skillfilter=this._appData.userEventSkills.filter(val=>{
          return val.id==wrt.skillReq.id;
        })
        if (skillfilter.length>0){
          let myskill=skillfilter[0]
          if (myskill.value==wrt.skillReq.quantity){
            //job complete
          }
          else{
            this.dialog=this.npcDialog.onWritIncomplete;

          }
        }
        else{
          this.dialog=onWritIncomplete;
        }

      }
      else{
        this.dialog=onWritIncomplete;

      }
      Swal.fire({title:"O trabalho incompleto",text:"O trabalho '"+wrt.title+"' ainda está incompleto. Termine ele para receber seus pontos."})

    }

    //writ receiver when writ is not complete
    public doWrit(writ,question){
        let update=false;
        let completed=0;
        let jobIndex=question.jobIndex;
        let rewardAction=question.rewardAction;

        if (writ.jobs.length>0){
          for (let i=0;i<writ.jobs.length;i++){
              let job=writ.jobs[jobIndex];
              if (job.completed) {
                completed++;
              }
              else{
                job.completed=true;
                completed++;
                writ.jobs[i]=job;
                update=true;
              }
              if (completed==writ.jobs.length){ writ.completed=true;}
          }
        }
        else{
          writ.completed=true;
          update=true;
        }
        if (writ.completed && rewardAction){
          this.doAction(question);
        }
          if (update){
            this._companyService.getUserWrit(this._appData.instagramUser,writ).set(writ).then(val=>{
                Swal.fire("Trabalho completo!!","Você completou o trabalho: '"+writ.title+"'.");
            });
        }
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/Modals/npc-modal-component.ts